// extracted by mini-css-extract-plugin
export var additionalBody = "styles-module--additionalBody--3qeTW";
export var bottomOfColumn = "styles-module--bottomOfColumn--x1tL6";
export var centerOfColumn = "styles-module--centerOfColumn--11vOY";
export var container = "styles-module--container--1Sx8Z";
export var footer = "styles-module--footer--1Cz_b";
export var header = "styles-module--header--1hV3X";
export var mainBody = "styles-module--mainBody--1B2rL";
export var sidebar = "styles-module--sidebar--3Wm9K";
export var title = "styles-module--title--2qmoX";
export var topOfColumn = "styles-module--topOfColumn--LKmD8";
export var twoColumnLayout = "styles-module--twoColumnLayout--3MJfP";